import { Icon } from '@livable/saas-react-components';
import { Button, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PostChargeModal from 'src/components/resident/PostChargeModal';
// import CreditModal from 'src/components/transactions/CreditModal';
import { tenantsArray } from 'src/configs/sampleData';
import useStyles from './styles';
export default function TopActionButtons(props) {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _props$openTenantModa = props.openTenantModal,
    openTenantModal = _props$openTenantModa === void 0 ? () => {} : _props$openTenantModa,
    _props$showMoveOut = props.showMoveOut,
    showMoveOut = _props$showMoveOut === void 0 ? false : _props$showMoveOut,
    handleRefreshTrigger = props.handleRefreshTrigger;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, showMoveOut && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => openTenantModal('move-out'),
    variant: "action",
    'custom-attribute': '815-resident-profile-page-top-actions-btns'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-out"
  }), t('resident_account.schedule_move_out'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4
  }, /*#__PURE__*/React.createElement(PostChargeModal, {
    tenantsList: tenantsArray,
    handleRefreshTrigger: handleRefreshTrigger
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 4
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    onClick: () => openTenantModal('overview'),
    'custom-attribute': '816-resident-profile-page-top-actions-btns'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('resident_account.edit_resident_details')))));
}
TopActionButtons.propTypes = {
  creditModal: PropTypes.shape({
    accountId: PropTypes.string,
    propertyId: PropTypes.string
  }),
  openTenantModal: PropTypes.func,
  showMoveOut: PropTypes.bool
};